import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild,
  input,
  output,
} from '@angular/core';
import { DsButtonDirective } from './button.directive';
import { DsIconComponent } from './icon.component';

@Component({
  selector: 'ds-dialog',
  imports: [DsButtonDirective, DsIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-overlay-host' },
  template: `<dialog #dialog class="ds-dialog" (close)="closed.emit()" (cancel)="cancel($event)">
    <div class="ds-dialog__header">
      <div>
        <p class="ds-eyebrow">{{ eyebrow() }}</p>
        <h2>{{ title() }}</h2>
      </div>
      <button dsButton variant="quiet" type="button" aria-label="Close dialog" (click)="close()">
        <ds-icon name="close" />
      </button>
    </div>
    <div class="ds-dialog__body"><ng-content /></div>
    <div class="ds-dialog__actions"><ng-content select="[dsDialogActions]" /></div>
  </dialog>`,
})
export class DsDialogComponent {
  @ViewChild('dialog', { static: true }) private readonly dialog!: ElementRef<HTMLDialogElement>;
  readonly title = input.required<string>();
  readonly eyebrow = input('');
  readonly dismissible = input(true);
  readonly closed = output<void>();
  open(): void {
    this.dialog.nativeElement.showModal();
  }
  close(): void {
    this.dialog.nativeElement.close();
  }
  cancel(event: Event): void {
    if (!this.dismissible()) event.preventDefault();
  }
}

@Component({
  selector: 'ds-drawer',
  imports: [DsButtonDirective, DsIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-overlay-host' },
  template: `<dialog #drawer class="ds-drawer" (close)="closed.emit()" (cancel)="cancel($event)">
    <div class="ds-drawer__header">
      <h2>{{ title() }}</h2>
      <button dsButton variant="quiet" type="button" aria-label="Close drawer" (click)="close()">
        <ds-icon name="close" />
      </button>
    </div>
    <div class="ds-drawer__body"><ng-content /></div>
  </dialog>`,
})
export class DsDrawerComponent {
  @ViewChild('drawer', { static: true }) private readonly drawer!: ElementRef<HTMLDialogElement>;
  readonly title = input.required<string>();
  readonly dismissible = input(true);
  readonly closed = output<void>();
  open(): void {
    this.drawer.nativeElement.showModal();
  }
  close(): void {
    this.drawer.nativeElement.close();
  }
  cancel(event: Event): void {
    if (!this.dismissible()) event.preventDefault();
  }
}
